export const OrderModelModule = angular
    .module('app.services.model.models.orderModel', [])
    .value('orderModel', {
        orderNumber: 'Number',
        taxRate: 'Number',
        taxAmount: 'Number',
        grandTotal: 'Number',
        refundedAmount: 'Number',
        paymentMethod: 'String',
        paymentSource: 'String',
        creditCardType: 'String',
        creditCardLastFour: 'String',
        shopperNote: 'String',
        merchantNote: 'String',
        placedBy: {
            firstName: 'String',
            lastName: 'String',
            emailAddress: 'String',
            phoneNumber: 'String',
            address: 'String',
            emailOptIn: 'Boolean'
        },
        cart: {
            items: 'Array',
            totalItems: 'Number',
            total: 'Number',
            taxRate: 'Number',
            taxAmount: 'Number',
            grandTotal: 'Number',
            revision: 'Number',
            shippingMethod: {
                name: 'String',
                shippingBand: {
                    totalThreshold: 'Number',
                    shippingPrice: 'Number'
                },
                shippingCost: 'Number'
            },
            postalCode: 'String',
            state: 'String',
            country: 'String'
        },
        deliverTo: {
            firstName: 'String',
            lastName: 'String',
            address: 'String',
            isResidential: 'Boolean'
        },
        shipped: ['Boolean', false],
        paid: ['Boolean', false],
        status: 'String',
        revision: 'Number',
        isCanceled: ['Boolean', false],
        isRefunded: ['Boolean', false],
        auditLogId: 'String',
        customerId: 'String',
        trackingInformation: {
            carrier: 'String',
            number: 'String'
        },
        stripeChargeId: 'String',
        stripeRefunds: 'Array',
        stripeEvents: 'Array',
        payPalEvents: 'Array',
        payPalPaymentCustomId: 'String',
        paymentLifecycle: 'Array',
        purchaseOrderNumber: 'String',
        fulfillmentLifecycle: 'Array',
        tenant: 'String',
        isImport: ['Boolean', false],
        paymentRequests: 'Array'
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/data/model/models/orders.model.js